export const BREAKPOINTS = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400,
};

export const MEDIA_QUERIES = {
  MOBILE: `(max-width: ${BREAKPOINTS.MD - 1}px)`,
  TABLET: `(min-width: ${BREAKPOINTS.MD}px) and (max-width: ${
    BREAKPOINTS.LG - 1
  }px)`,
  DESKTOP: `(min-width: ${BREAKPOINTS.LG}px)`,
  LARGE_DESKTOP: `(min-width: ${BREAKPOINTS.XL}px)`,
};
